import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentSipSlabsComponent } from './payment-sip-slabs.component';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { CurrencyDropdownModule } from '../currency-dropdown/currency-dropdown.module';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [PaymentSipSlabsComponent],
  exports: [PaymentSipSlabsComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    SharedModule,
    ReactiveFormsModule,
    CurrencyDropdownModule
  ]
})
export class PaymentSipSlabsModule { }
